/* eslint-disable max-lines */
import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import {
  DisplayOptions,
  MultiLineTextField,
  RadioOptionsField,
  TextField,
} from "../../../components";
import { CustomCheckBoxField } from "../../../components/CustomCheckBoxField/CustomCheckBoxField";
import { CustomMultiLineTextField } from "../../../components/CustomMultiLineTextField/CustomMultiLineTextField";
import { SubForm, SubFormNavigationProps } from "../../../components/SubForm";
import {
  pitchInfoDeveloperPublisherInitialValues,
  pitchInputsMaxLength,
  usePitchInformationPublisherDeveloperValidationSchema,
} from "../../../helpers/formValidation";
import { useStrings } from "../../../localization/localizationHelpers";
import { LocalProgramSubmitTypes } from "../../../models/pitchProgramSubmitTypes";
import {
  AlreadySignedUpIdXboxOptions,
  HavePublisherOptions,
  KitAlreadyOptions,
  LaunchedForConsoleOptions,
  StudioSizeOptions,
} from "../../../models/pitchUxModels";
import { getIsSavingForm } from "../../../redux/selectors";
import {
  PitchInformationFormId,
  PitchInformationSubFormsId,
} from "../PitchInformationPageConstants";
import * as styles from "./PublisherDeveloperSubForm.module.css";

const PublisherDeveloperSubForm = (props: SubFormNavigationProps) => {
  const [
    pitchPublisherDeveloperNameCompanyOrganizationTitle,
    pitchPublisherDeveloperNameCompanyOrganizationSubtitle,
    pitchPublisherDeveloperEmailAddressTitle,
    pitchPublisherDeveloperXboxContactTitle,
    pitchPublisherDeveloperXboxContactSubtitle,
    pitchPublisherDeveloperProgramConsiderationTitle,
    pitchPublisherDeveloperProgramOptionOneTitle,
    pitchPublisherDeveloperProgramOptionTwoTitle,
    pitchPublisherDeveloperProgramOptionThreeTitle,
    pitchPublisherDeveloperProgramReasonTitle,
    pitchPublisherDeveloperProgramReasonSubtitle,
    pitchPublisherDeveloperProgramSpecificAspectPrototypeTitle,
    pitchPublisherDeveloperProgramStudioSizeTitle,
    pitchPublisherDeveloperProgramStudioSizeOneToFourthTitle,
    pitchPublisherDeveloperProgramStudioSizeFiveToTenTitle,
    pitchPublisherDeveloperProgramStudioSizeTenToFifteenTitle,
    pitchPublisherDeveloperProgramStudioSizeFifteenToTwentyfiveTitle,
    pitchPublisherDeveloperProgramStudioSizeTwentyfiveToFortyfiveTitle,
    pitchPublisherDeveloperProgramStudioSizeFortyfiveToAboveTitle,
    pitchPublisherDeveloperProgramStudioPointOfContactTitle,
    pitchPublisherDeveloperProgramStudioCountryLocatedTitle,
    pitchPublisherDeveloperProgramYouHavePublisherTitle,
    pitchPublisherDeveloperProgramYouHavePublisherOptionYesOption,
    pitchPublisherDeveloperProgramYouHavePublisherOptionNoOption,
    pitchPublisherDeveloperProgramYouHavePublisherOptionNegotiatingOption,
    pitchPublisherDeveloperProgramYouHavePublisherOptionUnsureOption,
    pitchPublisherDeveloperProgramYouHavePublisherOptionSelfPublishingOption,
    pitchPublisherDeveloperProgramPublisherNameTitle,
    pitchPublisherDeveloperProgramStudioEstablishedTitle,
    pitchPublisherDeveloperProgramIntroductionDeckTitle,
    pitchPublisherDeveloperProgramCompanyWebsiteTitle,
    pitchPublisherDeveloperProgramAlreadySignedIdXboxTitle,
    pitchPublisherDeveloperProgramAlreadySignedIdXboxYesOption,
    pitchPublisherDeveloperProgramAlreadySignedIdXboxNoOption,
    pitchPublisherDeveloperProgramKitAlreadyTitle,
    pitchPublisherDeveloperProgramKitAlreadyYesOption,
    pitchPublisherDeveloperProgramKitAlreadyNoOption,
    pitchPublisherDeveloperProgramKitAlreadyUnknownOption,
    pitchPublisherDeveloperProgramLaunchedGameOnConsoleBeforeTitle,
    yes,
    no,
    pitchPublisherDeveloperProgramGamesLaunchedForConsoleTitle,
    other,
  ] = useStrings(
    "pitchPublisherDeveloperNameCompanyOrganizationTitle",
    "pitchPublisherDeveloperNameCompanyOrganizationSubtitle",
    "pitchPublisherDeveloperEmailAddressTitle",
    "pitchPublisherDeveloperXboxContactTitle",
    "pitchPublisherDeveloperXboxContactSubtitle",
    "pitchPublisherDeveloperProgramConsiderationTitle",
    "pitchPublisherDeveloperProgramOptionOneTitle",
    "pitchPublisherDeveloperProgramOptionTwoTitle",
    "pitchPublisherDeveloperProgramOptionThreeTitle",
    "pitchPublisherDeveloperProgramReasonTitle",
    "pitchPublisherDeveloperProgramReasonSubtitle",
    "pitchPublisherDeveloperProgramSpecificAspectPrototypeTitle",
    "pitchPublisherDeveloperProgramStudioSizeTitle",
    "pitchPublisherDeveloperProgramStudioSizeOneToFourthTitle",
    "pitchPublisherDeveloperProgramStudioSizeFiveToTenTitle",
    "pitchPublisherDeveloperProgramStudioSizeTenToFifteenTitle",
    "pitchPublisherDeveloperProgramStudioSizeFifteenToTwentyfiveTitle",
    "pitchPublisherDeveloperProgramStudioSizeTwentyfiveToFortyfiveTitle",
    "pitchPublisherDeveloperProgramStudioSizeFortyfiveToAboveTitle",
    "pitchPublisherDeveloperProgramStudioPointOfContactTitle",
    "pitchPublisherDeveloperProgramStudioCountryLocatedTitle",
    "pitchPublisherDeveloperProgramYouHavePublisherTitle",
    "pitchPublisherDeveloperProgramYouHavePublisherOptionYesOption",
    "pitchPublisherDeveloperProgramYouHavePublisherOptionNoOption",
    "pitchPublisherDeveloperProgramYouHavePublisherOptionNegotiatingOption",
    "pitchPublisherDeveloperProgramYouHavePublisherOptionUnsureOption",
    "pitchPublisherDeveloperProgramYouHavePublisherOptionSelfPublishingOption",
    "pitchPublisherDeveloperProgramPublisherNameTitle",
    "pitchPublisherDeveloperProgramStudioEstablishedTitle",
    "pitchPublisherDeveloperProgramIntroductionDeckTitle",
    "pitchPublisherDeveloperProgramCompanyWebsiteTitle",
    "pitchPublisherDeveloperProgramAlreadySignedIdXboxTitle",
    "pitchPublisherDeveloperProgramAlreadySignedIdXboxYesOption",
    "pitchPublisherDeveloperProgramAlreadySignedIdXboxNoOption",
    "pitchPublisherDeveloperProgramKitAlreadyTitle",
    "pitchPublisherDeveloperProgramKitAlreadyYesOption",
    "pitchPublisherDeveloperProgramKitAlreadyNoOption",
    "pitchPublisherDeveloperProgramKitAlreadyUnknownOption",
    "pitchPublisherDeveloperProgramLaunchedGameOnConsoleBeforeTitle",
    "yes",
    "no",
    "pitchPublisherDeveloperProgramGamesLaunchedForConsoleTitle",
    "other"
  );

  const validationSchema = usePitchInformationPublisherDeveloperValidationSchema();
  const isSavingFormToCrm = useSelector(getIsSavingForm);
  const [isProspectiveProgramsOtherChecked, setIsProspectiveProgramsOtherChecked] = useState<
    boolean | undefined
  >(undefined);
  const [launchedForConsole, setLaunchedForConsole] = useState<boolean | undefined>(undefined);
  const [youHavePublisherChecked, setYouHavePublisherChecked] = useState<boolean | undefined>(
    undefined
  );
  return (
    <SubForm
      validateConfig={validationSchema}
      initialValues={pitchInfoDeveloperPublisherInitialValues}
      formId={PitchInformationFormId}
      subFormId={PitchInformationSubFormsId.PublisherDeveloperInformation}
      {...props}
    >
      {/* <SectionTitle title={basicInfo} subtitle={describeTheGameYouAreApplyingFor} /> */}
      <Row className={styles.container}>
        <Column>
          <TextField
            name="nameCompanyOrganization"
            title={pitchPublisherDeveloperNameCompanyOrganizationTitle}
            subtitle={pitchPublisherDeveloperNameCompanyOrganizationSubtitle}
            isRequiredField={true}
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <TextField
            name="emailAddress"
            title={pitchPublisherDeveloperEmailAddressTitle}
            isRequiredField={true}
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <TextField
            name="xboxContact"
            title={pitchPublisherDeveloperXboxContactTitle}
            subtitle={pitchPublisherDeveloperXboxContactSubtitle}
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <CustomCheckBoxField
            checkBoxes={[
              {
                value: LocalProgramSubmitTypes.xboxGamePass,
                label: pitchPublisherDeveloperProgramOptionThreeTitle,
              },
              {
                value: LocalProgramSubmitTypes.developerAccelerationProgramPorting,
                label: pitchPublisherDeveloperProgramOptionOneTitle,
              },
              {
                value: LocalProgramSubmitTypes.developerAccelerationProgramPrototype,
                label: pitchPublisherDeveloperProgramOptionTwoTitle,
              },
              {
                value: LocalProgramSubmitTypes.other,
                label: other,
              },
            ]}
            name={"programConsiderationType"}
            title={pitchPublisherDeveloperProgramConsiderationTitle}
            display={DisplayOptions.column}
            isSaving={isSavingFormToCrm}
            isOtherChecked={isProspectiveProgramsOtherChecked}
            setChildInputForm={setIsProspectiveProgramsOtherChecked}
            isRequiredField
          />
          <MultiLineTextField
            name="reasonOfGoodFit"
            title={pitchPublisherDeveloperProgramReasonTitle}
            subtitle={pitchPublisherDeveloperProgramReasonSubtitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <MultiLineTextField
            name="specificAspectToPrototype"
            title={pitchPublisherDeveloperProgramSpecificAspectPrototypeTitle}
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <RadioOptionsField
            isRequiredField
            options={[
              {
                value: StudioSizeOptions.OneToFour,
                label: pitchPublisherDeveloperProgramStudioSizeOneToFourthTitle,
              },
              {
                value: StudioSizeOptions.FiveToTen,
                label: pitchPublisherDeveloperProgramStudioSizeFiveToTenTitle,
              },
              {
                value: StudioSizeOptions.TenToFifteen,
                label: pitchPublisherDeveloperProgramStudioSizeTenToFifteenTitle,
              },
              {
                value: StudioSizeOptions.FifteenToTwentyFive,
                label: pitchPublisherDeveloperProgramStudioSizeFifteenToTwentyfiveTitle,
              },
              {
                value: StudioSizeOptions.TwentyFiveToFourtyFive,
                label: pitchPublisherDeveloperProgramStudioSizeTwentyfiveToFortyfiveTitle,
              },
              {
                value: StudioSizeOptions.FourtyFiveToAbove,
                label: pitchPublisherDeveloperProgramStudioSizeFortyfiveToAboveTitle,
              },
            ]}
            name="studioSize"
            title={pitchPublisherDeveloperProgramStudioSizeTitle}
            listAsColumn
            isSaving={isSavingFormToCrm}
          />
          <TextField
            name="studioPointOfContact"
            title={pitchPublisherDeveloperProgramStudioPointOfContactTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <TextField
            name="countryLocated"
            title={pitchPublisherDeveloperProgramStudioCountryLocatedTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <RadioOptionsField
            isRequiredField
            options={[
              {
                value: HavePublisherOptions.Yes,
                label: pitchPublisherDeveloperProgramYouHavePublisherOptionYesOption,
              },
              {
                value: HavePublisherOptions.No,
                label: pitchPublisherDeveloperProgramYouHavePublisherOptionNoOption,
              },
              {
                value: HavePublisherOptions.Negotiating,
                label: pitchPublisherDeveloperProgramYouHavePublisherOptionNegotiatingOption,
              },
              {
                value: HavePublisherOptions.Unsure,
                label: pitchPublisherDeveloperProgramYouHavePublisherOptionUnsureOption,
              },
              {
                value: HavePublisherOptions.SelfPublishing,
                label: pitchPublisherDeveloperProgramYouHavePublisherOptionSelfPublishingOption,
              },
            ]}
            name="youHavePublisher"
            title={pitchPublisherDeveloperProgramYouHavePublisherTitle}
            listAsColumn
            isSaving={isSavingFormToCrm}
            setChildInputForm={setYouHavePublisherChecked}
          />
          <CustomMultiLineTextField
            name="publisherName"
            title={pitchPublisherDeveloperProgramPublisherNameTitle}
            isSaving={isSavingFormToCrm}
            parentChecked={youHavePublisherChecked}
            isRequiredField={youHavePublisherChecked}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <TextField
            name="studioEstablished"
            title={pitchPublisherDeveloperProgramStudioEstablishedTitle}
            isSaving={isSavingFormToCrm}
            isRequiredField
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <TextField
            name="introductionDeckStudio"
            title={pitchPublisherDeveloperProgramIntroductionDeckTitle}
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <TextField
            name="companyWebsite"
            title={pitchPublisherDeveloperProgramCompanyWebsiteTitle}
            isSaving={isSavingFormToCrm}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
          <RadioOptionsField
            isRequiredField
            options={[
              {
                value: AlreadySignedUpIdXboxOptions.Yes,
                label: pitchPublisherDeveloperProgramAlreadySignedIdXboxYesOption,
              },
              {
                value: AlreadySignedUpIdXboxOptions.No,
                label: pitchPublisherDeveloperProgramAlreadySignedIdXboxNoOption,
              },
            ]}
            name="signedUpIdXbox"
            title={pitchPublisherDeveloperProgramAlreadySignedIdXboxTitle}
            listAsColumn
            isSaving={isSavingFormToCrm}
          />
          <RadioOptionsField
            isRequiredField
            options={[
              {
                value: KitAlreadyOptions.Yes,
                label: pitchPublisherDeveloperProgramKitAlreadyYesOption,
              },
              {
                value: KitAlreadyOptions.No,
                label: pitchPublisherDeveloperProgramKitAlreadyNoOption,
              },
              {
                value: KitAlreadyOptions.Unknown,
                label: pitchPublisherDeveloperProgramKitAlreadyUnknownOption,
              },
            ]}
            name="kitAlready"
            title={pitchPublisherDeveloperProgramKitAlreadyTitle}
            listAsColumn
            isSaving={isSavingFormToCrm}
          />
          <RadioOptionsField
            isRequiredField
            options={[
              {
                value: LaunchedForConsoleOptions.Yes,
                label: yes,
              },
              {
                value: LaunchedForConsoleOptions.No,
                label: no,
              },
            ]}
            name="launchedForConsole"
            title={pitchPublisherDeveloperProgramLaunchedGameOnConsoleBeforeTitle}
            listAsColumn
            isSaving={isSavingFormToCrm}
            setChildInputForm={setLaunchedForConsole}
          />
          <CustomMultiLineTextField
            name="listGameLaunchedOnConsole"
            title={pitchPublisherDeveloperProgramGamesLaunchedForConsoleTitle}
            isSaving={isSavingFormToCrm}
            parentChecked={launchedForConsole}
            maxLengthsByFieldName={pitchInputsMaxLength}
          />
        </Column>
      </Row>
    </SubForm>
  );
};

export default PublisherDeveloperSubForm;
